import React, { useState, Component } from 'react';
import { Calendar, Clock, Phone, MessageCircle, CheckCircle, ChevronRight } from 'lucide-react';
import { Button } from '../ui/Button';
const SERVICES = ['General Medical Consultations', 'Minor Surgical Procedures', 'Safe Medical Circumcision', 'Paternity Testing (DNA)', 'Immunizations', 'Pre-Employment Medical Examinations', 'Family Planning', 'Counseling Services', 'Chronic Disease Management', 'Physiotherapy', 'Optician Services', 'Antenatal Care', 'Postnatal Care', 'Laboratory Services', 'ECG Services', 'Ultrasound Services', 'Dentistry', 'Audiometry', 'Spirometry'];
const TIME_SLOTS = ['08:00 AM', '09:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '02:00 PM', '03:00 PM', '04:00 PM', '05:00 PM'];
export function AppointmentSection() {
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    date: '',
    time: '',
    notes: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const update = (field: string, value: string) => setForm(prev => ({
    ...prev,
    [field]: value
  }));
  const isValid = form.name && form.phone && form.service && form.date;
  const whatsappLink = `https://wa.me/26773241613?text=${encodeURIComponent(`Hello Maisha Medical Center.\nI would like to book an appointment.\nName: ${form.name}\nPhone: ${form.phone}\nPreferred Service: ${form.service}\nPreferred Date: ${form.date}\nPreferred Time: ${form.time}\n\nPlease assist me.`)}`;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!isValid) return;
    setSubmitted(true);
  };
  return <section className="relative py-24 overflow-hidden" data-id="element-59" data-mp="w4w71on4xrib">
      {/* Background image */}
      <img src="https://cdn.magicpatterns.com/uploads/qbGmSXCEC9QH6TthgTKZco/maisha_edited_6.jpg" alt="Maisha Medical Center reception and waiting area" className="absolute inset-0 w-full h-full object-cover" data-id="element-60" data-mp="w6piriclv1x6" />
      {/* Brand navy color overlay */}
      <div className="absolute inset-0 bg-brand-navy/90" data-id="element-61" data-mp="2ws7jcp85e7gp" />
      <div className="absolute inset-0 bg-gradient-to-r from-brand-navy via-brand-navy/85 to-brand-navy/70" data-id="element-62" data-mp="2sr5k48e8dveq" />

      <div className="relative z-10 max-w-brand mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63" data-mp="2nznjjlg4dwua">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center" data-id="element-64" data-mp="2j241eagawzx2">
          {/* Intro copy */}
          <div className="w-full lg:w-1/2 text-white" data-id="element-65" data-mp="2e3kgmddg1u6a">
            <span className="font-semibold tracking-wider text-sm uppercase mb-3 block text-[#FFFFFF]" data-id="element-66" data-mp="2e052pdviar6g">
              Book Your Visit
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-6 leading-tight" data-id="element-67" data-mp="252m9vnbmf8k0">
              Request an Appointment Today
            </h2>
            <p className="text-slate-200 text-lg leading-relaxed mb-8 max-w-xl" data-id="element-68" data-mp="3azp43ibo9vz">
              Schedule your visit to Maisha Medical Center in just a few
              moments. Fill in your details and our reception team will confirm
              your appointment promptly.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-69" data-mp="atfqytk1pf1u">
              {['Trusted, experienced healthcare professionals', 'Comprehensive services under one roof', 'Fast confirmation via call or WhatsApp'].map(item => <li key={item} className="flex items-center gap-3" data-id="element-70" data-mp="kllla9xrs8k7">
                  <CheckCircle className="w-6 h-6 text-brand-gold shrink-0" data-id="element-71" data-mp="3j2z9wjl926qp" />
                  <span className="text-slate-100 font-medium" data-id="element-72" data-mp="3o1kawl8bsug7">{item}</span>
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-6" data-id="element-73" data-mp="3syapt58e9k01">
              <a href="tel:+2676540244" className="flex items-center gap-3 text-white group" data-id="element-74" data-mp="wuks4wahxwf">
                <span className="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-brand-red transition-colors" data-id="element-75" data-mp="18bfsaaver2wj">
                  <Phone className="w-5 h-5" data-id="element-76" data-mp="1aszr0pklspy1" />
                </span>
                <span data-id="element-77" data-mp="15upv2cr21lbd">
                  <span className="block text-xs text-slate-300" data-id="element-78" data-mp="15v8284f99jy2">Call us</span>
                  <span className="font-semibold" data-id="element-79" data-mp="1kryy43pq0dix">+267 6540244</span>
                </span>
              </a>
              <div className="flex items-center gap-3 text-white" data-id="element-80" data-mp="1ft5l0cecioja">
                <span className="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center" data-id="element-81" data-mp="1fuyvk2s2xswk">
                  <Clock className="w-5 h-5 text-brand-gold" data-id="element-82" data-mp="1tqaoq5ql7bbd" />
                </span>
                <span data-id="element-83" data-mp="1otajty5h4elu">
                  <span className="block text-xs text-slate-300" data-id="element-84" data-mp="23igqg76n573r">
                    Operating hours
                  </span>
                  <span className="font-semibold" data-id="element-85" data-mp="1yj3t2si58hmx">Mon–Fri 8am–6pm</span>
                </span>
              </div>
            </div>
          </div>

          {/* Form card */}
          <div className="w-full lg:w-1/2" data-id="element-86" data-mp="28hjnb4cgw70n">
            <div className="bg-white rounded-2xl shadow-soft-lg p-6 md:p-8" data-id="element-87" data-mp="28iuocwej30o2">
              {submitted ? <div className="text-center py-8" data-id="element-88" data-mp="2r6daloahkmlr">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-89" data-mp="2w4oihth80n1c">
                    <CheckCircle className="w-8 h-8 text-green-600" data-id="element-90" data-mp="2i5yledueincz" />
                  </div>
                  <h3 className="text-2xl font-heading font-bold text-brand-navy mb-3" data-id="element-91" data-mp="2n3qn1zkulnud">
                    Request Received!
                  </h3>
                  <p className="text-slate-600 mb-8" data-id="element-92" data-mp="28e172y83jfa1">
                    Thank you, {form.name}. Our team will contact you shortly to
                    confirm your appointment for{' '}
                    <strong className="text-brand-navy" data-id="element-93" data-mp="1zg8qzrujw3ll">{form.service}</strong>.
                  </p>
                  <Button href={whatsappLink} target="_blank" variant="primary" fullWidth icon={<MessageCircle className="w-5 h-5" data-id="element-95" data-mp="1uejj2l2mk61q" />} className="bg-[#25D366] hover:bg-[#20bd5a] focus:ring-[#25D366]" data-id="element-94" data-mp="23giyxa1wl433">
                    Confirm on WhatsApp
                  </Button>
                </div> : <>
                  <div className="flex items-center gap-3 mb-6" data-id="element-96" data-mp="3ndi0aw1wjrxw">
                    <div className="w-11 h-11 rounded-xl bg-brand-red/10 flex items-center justify-center text-brand-red" data-id="element-97" data-mp="3idc18utaz35s">
                      <Calendar className="w-6 h-6" data-id="element-98" data-mp="iyi7b9h3pt97" />
                    </div>
                    <h3 className="text-xl font-heading font-bold text-brand-navy" data-id="element-99" data-mp="ewwnf465gepi">
                      Appointment Details
                    </h3>
                  </div>

                  <form onSubmit={handleSubmit} className="space-y-4" data-id="element-100" data-mp="9zmxzoirg31o">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-101" data-mp="4xxnc9zg9re4">
                      <div data-id="element-102" data-mp="2uosw2o5jv6hx">
                        <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-103" data-mp="2up2nmg68tlpq">
                          Full Name *
                        </label>
                        <input required type="text" value={form.name} onChange={e => update('name', e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-red/20 focus:border-brand-red transition-all" placeholder="John Doe" data-id="element-104" data-mp="2flj1y04ylucw" />
                      </div>
                      <div data-id="element-105" data-mp="339aqq37orzv2">
                        <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-106" data-mp="338hgutdfku8p">
                          Phone Number *
                        </label>
                        <input required type="tel" value={form.phone} onChange={e => update('phone', e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-red/20 focus:border-brand-red transition-all" placeholder="+267 ..." data-id="element-107" data-mp="3d8rvmif469pz" />
                      </div>
                    </div>

                    <div data-id="element-108" data-mp="3uh12fqmh4vr4">
                      <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-109" data-mp="3pir79g0r1v5i">
                        Email Address
                      </label>
                      <input type="email" value={form.email} onChange={e => update('email', e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-red/20 focus:border-brand-red transition-all" placeholder="john@example.com" data-id="element-110" data-mp="31totij98kmga" />
                    </div>

                    <div data-id="element-111" data-mp="m2sh93ma778z">
                      <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-112" data-mp="m1hen74ko5jg">
                        Preferred Service *
                      </label>
                      <select required value={form.service} onChange={e => update('service', e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-red/20 focus:border-brand-red transition-all bg-white text-slate-700" data-id="element-113" data-mp="yl61rt19vdr0">
                        <option value="" disabled data-id="element-114" data-mp="1ha2uhsh0ty74">
                          Select a service
                        </option>
                        {SERVICES.map(service => <option key={service} value={service} data-id="element-115" data-mp="17kt189afy9hf">
                            {service}
                          </option>)}
                      </select>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-116" data-mp="202nj2xpoth54">
                      <div data-id="element-117" data-mp="1k0aedvmcfoav">
                        <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-118" data-mp="1k24wz3a574bs">
                          Preferred Date *
                        </label>
                        <input required type="date" value={form.date} onChange={e => update('date', e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-red/20 focus:border-brand-red transition-all text-slate-700" data-id="element-119" data-mp="1a35nxjlgt6o9" />
                      </div>
                      <div data-id="element-120" data-mp="rabl1o14950e">
                        <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-121" data-mp="wapostvopssm">
                          Preferred Time
                        </label>
                        <select value={form.time} onChange={e => update('time', e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-red/20 focus:border-brand-red transition-all bg-white text-slate-700" data-id="element-122" data-mp="hgb5stc4ejdy">
                          <option value="" data-id="element-123" data-mp="cncsfpqiw4k3">Any time</option>
                          {TIME_SLOTS.map(slot => <option key={slot} value={slot} data-id="element-124" data-mp="7spayatxsaf0">
                              {slot}
                            </option>)}
                        </select>
                      </div>
                    </div>

                    <div data-id="element-125" data-mp="vevy64bxlwpt">
                      <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-126" data-mp="vf5k9gtuvjq8">
                        Additional Notes
                      </label>
                      <textarea rows={2} value={form.notes} onChange={e => update('notes', e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-red/20 focus:border-brand-red transition-all resize-none" placeholder="Any specific concerns or symptoms?" data-id="element-127" data-mp="15dbpo8evf7zu" />
                    </div>

                    <Button type="submit" variant="primary" fullWidth disabled={!isValid} icon={<ChevronRight className="w-5 h-5" data-id="element-129" data-mp="1v79m4c0yq2sx" />} data-id="element-128" data-mp="1m7ea64zl23ru">
                      Request Appointment
                    </Button>
                    <p className="text-xs text-slate-400 text-center" data-id="element-130" data-mp="207owqvtv0w77">
                      Prefer the full booking experience?{' '}
                      <a href="/book" className="text-brand-red font-medium" data-id="element-131" data-mp="5t4hiyob5sv7">
                        Book step-by-step
                      </a>
                    </p>
                  </form>
                </>}
            </div>
          </div>
        </div>
      </div>
    </section>;
}